module.exports = __webpack_public_path__ + "img/map.e899ce70.png";